<template>
  <div class="wrap">
    <header>
      <img src="../assets/banner5.png" alt="">
    </header>
    <div class="headline">
      <p>用户注册</p>
      <span>User registration</span>
    </div>
    <form class="card" @submit.prevent="register">
      <div class="fills">
        <div class="num">
          <div class="phone">
            <label for="">手机号：</label>
            <select v-model="user.area_code">
              <option v-for="(item,index) in city" :key="index" :value="item.value">{{item.text}}</option>
            </select>
            <input type="text" v-model="user.tel" placeholder="手机号">
          </div>
          <div class="code">
            <input type="text" v-model="user.code" placeholder="验证码">
            <button type="button" @click="getCode">{{timeFlag?time:"发送验证码"}}</button>
          </div>
          <div class="info">
            <label for="">用户名：</label>
            <input type="text" v-model="user.nick_name" placeholder="用户名">
          </div>
          <div class="info">
            <label for="">密码：</label>
            <input type="password" v-model="user.pwd" placeholder="密码">
          </div>
          <div class="info">
            <label for="">重复密码：</label>
            <input type="password" v-model="user.repeat_pwd" placeholder="重复密码">
          </div>
        </div>
        <div class="reminder">
          <p>温馨提示：</p>
          <div>
            <p>如果您是我们的会员，请登录</p>
            <p>注册成为会员，您可以享受更多的服务！</p>
            <p>+积分奖励</p>
            <p>+保价优惠</p>
            <p>+快件信息订阅</p>
            <p>·····</p>
          </div>
        </div>
      </div>
      <div class="bind">
        <input type="submit" value="注册" style="cursor: pointer">
      </div>
    </form>
    <tips :flag="tipsFlag"></tips>
  </div>
</template>
<script>
  import {mapState} from 'vuex'
  import {check_phone_uni} from "../services/selectSide"
  import {userRegister} from '@/services/home'
  import tips from '../components/tips'

  export default {
    name: 'UserRegistration',
    props: {},
    components: {
      tips
    },
    data() {
      return {
        time: 60,
        timeFlag: false,
        user: {
          nick_name: '',
          pwd: '',
          repeat_pwd: '',
          tel: '',
          code: '',
          area_code: '+61',
          wx_nick_name: '',
          wx_openid: '',
          wx_avatar: '',
          wx_sex: '',
          wx_unionid: '',


        }
      }
    },
    computed: {
      ...mapState({
        city: state => state.city,
        check_code: state => state.check_code,
        wx_code: state => state.wx_code,
        register_param: state => state.register_param,
        tipsFlag: state => state.tipsFlag,
        redirectUrl: state => state.redirectUrl
      })
    },
    methods: {
      register() {
        if (!this.user.tel || !this.user.code || !this.user.nick_name || !this.user.pwd || !this.user.repeat_pwd) {
          this.$store.commit('setTipsFlag', {tips: '请将信息填写完整', search_flag: true, tipsCode: 2});
          return
        }
        if (this.user.pwd != this.user.repeat_pwd) {
          this.$store.commit('setTipsFlag', {tips: '两次密码输入不一致', search_flag: true, tipsCode: 2});
          return
        }
        var content = {
          tel: this.user.tel,
          code: this.user.code,
          pwd: this.user.pwd,
          user_name: this.user.nick_name,
          repeat_pwd: this.user.repeat_pwd,
          nick_name: this.user.wx_nick_name,
          openid: this.user.wx_openid,
          avatar: this.user.wx_avatar,
          sex: this.user.wx_sex,
          unionid: this.user.wx_unionid
        }

        userRegister({content: JSON.stringify(content)}).then(res => {
          if (res.code == 1) {
            this.$store.commit('setTipsFlag', {tips: res.message, search_flag: true, tipsCode: 1});
            location.href = this.redirectUrl.split('?')[0];
          } else {
            this.$store.commit('setTipsFlag', {tips: res.message, search_flag: true, tipsCode: 2});
          }
        })
      },
      getCode(e) {
        if (this.user.tel === '') {
          this.$store.commit('setTipsFlag', {tips: '您还没有输入手机号', search_flag: true, tipsCode: 2});
        } else {
          this.countdown(e);
          check_phone_uni({phone: this.user.tel}).then(res => {
            if (res.code == 1) {
              this.$store.dispatch('sendMsg', {
                tel: this.user.tel,
                area_code: this.user.area_code
              })
            } else {

              this.$store.commit('setTipsFlag', {tips: res.message, search_flag: true, tipsCode: 2});
            }
          })
        }
      },
      countdown(e) {
        if (this.time === 0) {
          e.target.removeAttribute('disabled', false);
          this.timeFlag = false;
          this.time = 60;
        } else {
          this.timeFlag = true;
          if (this.user.code) {
            e.target.removeAttribute('disabled', false)
            this.timeFlag = false;
            this.time = 60;
          } else {
            e.target.setAttribute('disabled', true);
            this.time--;
            let that = this;
            setTimeout(function () {
              that.countdown(e);
            }, 1000)
          }
        }
      }
    },
    created() {
      var that = this;
      // 不为空说明是扫码登陆进来的
      console.log(that.register_param)
      if (that.register_param) {
        if (that.register_param.data.is_register == 1) {
          that.user.wx_openid = that.register_param.data.openid;
          that.user.wx_nick_name = that.register_param.data.nick_name;
          that.user.wx_avatar = that.register_param.data.avatar;
          that.user.wx_sex = that.register_param.data.sex;
          that.user.wx_unionid = that.register_param.data.unionid;
        }
      }


    },
    mounted() {
      this.$store.dispatch('getCities');
      this.$store.dispatch('loginIndex');
    }
  }
</script>
<style scoped lang="scss">
  .wrap {
    width: 1000px;
    margin: 0 auto;
    margin-bottom: 94px;
  }

  .userLogin {
    min-width: 200px;
    height: 50px;
    background: #666;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-top: -25px;
    margin-left: -100px;
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    padding: 0 10px;
    box-sizing: border-box;
    img {
      width: 25px;
      height: 25px;
      margin-right: 5px;
    }
    p {
      font-size: 17px;
      color: #fff;
      font-weight: bold;
    }
  }

  .headline {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .card {
    width: 1000px;
    margin: 0 auto;
  }

  .fills {
    height: 414px;
    background: #4c4c4c;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 68px;
    .num {
      display: flex;
      flex-direction: column;
      .phone {
        display: flex;
        margin: 10px 0;
        label {
          color: #fff;
          height: 35px;
          line-height: 35px;
          width: 100px;
          text-align: right;
          margin-right: 10px;
        }
        select {
          width: 120px;
          margin-right: 20px;
        }
        input {
          flex: 1;
          height: 35px;
          padding-left: 5px;
          box-sizing: border-box;
        }
      }
      .code {
        display: flex;
        margin: 10px 0;
        button {
          width: 100px;
          height: 35px;
          margin-left: 20px;
          border: none;
          color: #fff;
          background: $bg-color;
          border-radius: 5px;
        }
        input {
          flex: 1;
          padding-left: 5px;
          margin-left: 110px;
        }
      }
      .info {
        display: flex;
        height: 35px;
        margin: 10px 0;
        margin-left: 80px;
        label {
          color: #fff;
          height: 35px;
          line-height: 35px;
          width: 110px;
          text-align: right;
          margin-right: 10px;
          margin-left: -90px;
        }
        input {
          width: 370px;
          height: 35px;
          background: #fff;
          border: none;
          padding-left: 5px;
        }
      }
    }
    .reminder {
      color: #fff;
      text-align: left;
      p {
        margin-left: 10px;
      }
      div {
        width: 205px;
        min-height: 175px;
        border: 1px dashed #fff;
        border-radius: 10px;
        padding: 5px 8px 5px 0;
        margin-top: 8px;
        p {
          font-size: 12px;
          line-height: 17px;
          font-weight: normal;
        }
      }
    }
  }

  .bind {
    height: 69px;
    background: $bg-color;
    display: flex;
    align-items: center;
    justify-content: center;
    input {
      width: 109px;
      height: 42px;
      background: #fff;
      border-radius: 10px;
      border: none;
      color: $bg-color;
      font-size: 18px;
      font-weight: bold;
    }
  }

  .model {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    background: rgba(0, 0, 0, .5);
    .elastic {
      width: 300px;
      height: 100px;
      background: #fff;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -150px;
      margin-left: -150px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      p {
        font-size: 18px;
      }
      button {
        width: 60px;
        height: 30px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/UserRegistration.vue